export const PREFERENCE_TYPES = {
  liveAgent:    'MEMBERPREFERENCETYPE_LIVEAGENT',
  emergency:    'MEMBERPREFERENCETYPE_911CALLASSIST',
  emotionalDistress: 'MEMBERPREFERENCETYPE_EMOTIONALDISTRESS',
  threeWayCall: 'MEMBERPREFERENCETYPE_3WAYCALL'
};

export const defaultCheckboxValues = {
  MEMBERPREFERENCETYPE_LIVEAGENT: {
    turn_on: false
  },
  MEMBERPREFERENCETYPE_911CALLASSIST: {
    turn_on: false
  },
  MEMBERPREFERENCETYPE_3WAYCALL: {
    turn_on: false
  },
  MEMBERPREFERENCETYPE_EMOTIONALDISTRESS: {
    turn_on: false
  }
};
